
// You can write more code here

/* START OF COMPILED CODE */

import DecorationImage from "../DecorationImage";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class DecorationCave extends DecorationImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 490, y ?? 357, texture || "game-all", frame ?? "transition-cave.png");

    this.scaleX = 1.33;
    this.scaleY = 1.33;

    // this (prefab fields)
    this.zIndex = 1;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
